export const Application = {
    EXTERNAL: 'EXTERNAL',
    AGORA: 'AGORA',
    APERTURE: 'APERTURE',
    COMPASS: 'COMPASS',
    LIGHTHOUSE: 'LIGHTHOUSE',
    MKT: 'MKT',
    HUBBLE: 'HUBBLE',
    RTA: 'RTA',
};

export const ApplicationDisplayTextMap = {
    [Application.EXTERNAL]: 'All External Applications',
    [Application.AGORA]: 'Agora',
    [Application.APERTURE]: 'FMH for Payers',
    [Application.COMPASS]: 'Compass',
    [Application.LIGHTHOUSE]: 'Lighthouse',
    [Application.MKT]: 'FMH for Pharmacies',
    [Application.HUBBLE]: 'Hubble',
    [Application.RTA]: 'Real Time Auth',
};

export const formatDisplayColText = (display) => (display ? 'On' : 'Off');
